import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "table table-striped" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Importo lordo",
            text: "Importo lordo"
          })
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "% iva",
            text: "% iva"
          }),
          _cache[3] || (_cache[3] = _createTextVNode(" (0 - 100) "))
        ]),
        (!_ctx.hidePoints)
          ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
              _createVNode(_component_localized_text, {
                localizedKey: "Punti",
                text: "Punti"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.grossAmount) = $event))
          }, null, 512), [
            [_vModelText, _ctx.localValue.grossAmount]
          ])
        ]),
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.vatPerc) = $event))
          }, null, 512), [
            [_vModelText, _ctx.localValue.vatPerc]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$filters.currency(_ctx.localValue.grossAmount * _ctx.localValue.vatPerc / 100)), 1)
        ]),
        (!_ctx.hidePoints)
          ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.points) = $event))
              }, null, 512), [
                [_vModelText, _ctx.localValue.points]
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}